<template>
    <div class="helpBox privacy" id="agreementBox">
        <h1 style="padding-bottom: 40px;"><img src="//img.fenfenriji.com/ED/56/AF/Image/E77B9F1F-76BF-0F75-20EB-5AB1C50671F0.png" alt="" style="display: block; width: 300px; margin: 0 auto;"></h1>
        <p>粉粉日记是中立的平台服务提供方，仅为用户发布的内容提供存储空间服务，粉粉日记不对用户发表、转载的内容提供任何形式的保证。任何个人或单位（以下简称“投诉人”）如认为粉粉日记网上存在侵犯自身合法权益的内容，可以按照本《投诉指引》向粉粉日记发起投诉，粉粉日记将根据相关法律法规的规定进行处理。</p>
        <h2><i class="fill fill3"></i>投诉流程</h2>
        <h3>1．发起投诉：</h3>
        <p>投诉人认为粉粉日记网上存在的内容侵犯其合法权益，可按以下要求提交相关关材料进行投诉：</p>
        <p>投诉人应向粉粉日记提出书面投诉《粉粉日记侵权投诉表》，内容应包括但不限于以下内容：</p>
        <p>（1）投诉人主体信息及相关材料，包括但不限于：</p>
        <p>
            1）投诉主体姓名/名称（单位/社会团体需同时提供法定代表人姓名) 、联系电话、有效身份证件及编号、Email、通信地址<br>
            2）投诉主体有效身份证件复印件，投诉人是个人，如提供的是居民身份证，请提供正反两面复印件；如是其他证件，请提供证件首页和个人页复印件。如投诉人是单位/社会团体等，需要提供投诉主体加盖公章的合法执照复印件。<br>
            3）如有代理人，请附加代理人有效身份证件复印件，及投诉人对代理人的有效授权委托书，委托书需要投诉人手写签名或加盖公章。
        </p>
        <p>（2）投诉事项及投诉请求</p>
        <p>投诉人投诉侵权的相关事项详细说明。</p>
        <p>（3）投诉人提交的构成侵权的初步证明材料，包括但不限于：</p>
        <p>
            1）投诉人的权属证明材料：著作权登记证书、商标注册证、专利权证书、合法出版物、创作手稿等能证明权利人拥有相关权利的有效权属证明。
            2）被投诉人构成侵权的证明材料：包括但不限于被投诉人发布的帖子侵犯了投诉人的名誉、商誉、隐私、肖像等权利的证据、被投诉人发布的帖子侵犯了投诉人著作权、商标权、专利权等权利的证据材料等。
        </p>
        <p>（4）投诉人声明</p>
        <p>投诉人明确保证：所提供的全部材料真实，对被投诉用户发布内容中存在侵犯权益的指控真实，并承担因要求粉粉日记删除该用户发布的帖子所引起的一切法律后果和连带责任。</p>
        <p>投诉人在提供的所有材料上填写日期，并手写签名/加盖公章。</p>
        <h3>2．粉粉日记依法处理投诉人的投诉</h3>
        <p>粉粉日记在接到投诉人符合法定条件的投诉及材料后，将会根据中国大陆法律法规的规定及时进行处理。</p>
        <p>在符合法律要求的前提下，粉粉日记会将投诉人的投诉材料转送给被投诉人。若被投诉人提供证据证明被投诉人未侵犯投诉人合法权益的，粉粉日记亦会按照法律规定进行处理，且在符合法律要求的前提下，粉粉日记会将被投诉人提交的材料转送给投诉人。</p>
        <h2><i class="fill fill3"></i>投诉方式</h2>
        <p>投诉人将填写完整的前述《粉粉日记侵权投诉表》及其他相关证明材料，清晰拍照或扫描后，发送至粉粉日记官方客服邮箱（service@ffrj.net）提交投诉申请，并等待粉粉日记审核处理。</p>

            <h2 style="padding-bottom: 30px">在法律允许的范围内，粉粉日记有权随时更改本《投诉指引》，粉粉日记对本《投诉指引》享有最终解释权。</h2>
        <a href="http://d.fenfenriji.com/web/act/privacypolicy/tabttsinfo.doc" target="_blank" download="filename" style="display: block; font-size: 17px;padding-bottom: 30px">《粉粉日记侵权投诉表》</a>
        <div style="height: 30px;"></div>
    </div>
</template>
<script>
    export default {

    }
</script>



// WEBPACK FOOTER //
// src/components/agreement/agreement1.vue